import React, { useContext } from "react";
import { Envs, SearchResultPlan } from "../../@types";
import { StarRating } from "..";
import { getPlanName } from "../../helpers/planHelpers";
import { useAppContext } from "../../helpers/context-hooks/useAppContext";
import { useTranslate } from "../../helpers/intlHooks";
import { PreviewContext } from "../../helpers/PreviewContext";
import { getEnvironment } from "../../helpers/urlHelpers";
import { makePlanDisplayId } from "../../helpers/objectUtilities";
import { isMMPlanCategory } from "../../helpers/planTypes";

interface PlanCardHeaderProps {
  plan: SearchResultPlan;
}

const PlanCardHeader: React.FunctionComponent<PlanCardHeaderProps> = ({
  plan,
}) => {
  const t = useTranslate();
  const {
    state: { language },
  } = useAppContext();
  const previewMode = useContext(PreviewContext);
  const isIMPEnvironment = getEnvironment() === Envs.imp;

  return (
    <div className="ds-u-margin-bottom--3">
      <h2
        id={`${plan.id}-heading`}
        className="PlanCard__header"
        data-cy="plan-card-header"
      >
        {getPlanName(plan, language)}
      </h2>
      <div className="PlanCard__sub_header">
        <span>{plan.organization_name}</span>
        <span aria-hidden className="ds-u-color--gray-light">
          {" "}
          |{" "}
        </span>
        <span>
          {t("plan_terms.plan_id")} {makePlanDisplayId(plan)}
        </span>
      </div>
      {(!previewMode || isIMPEnvironment) &&
        !isMMPlanCategory(plan.category) && (
          <StarRating
            lowPerforming={plan.low_performing}
            highPerforming={plan.high_performing}
            stars={plan.overall_star_rating}
            plan={plan}
            planYear={plan.contract_year}
          />
        )}
    </div>
  );
};

export default PlanCardHeader;
